<template>
<img src="../../assets/marca.png" alt="Gestão de Contrato" :style="{height}"/>
</template>

<script>
export default {
  name: "AppLogo",
  props: ['height']
}
</script>

<style scoped>

</style>